
import {TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { cssClass } from '../../style';

const cssPrefix = 'UserSettingsPage';

export namespace UserSettingsStyle {
  export const userSettingsRoot = cssClass(cssPrefix, 'root', {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: 'auto',
    backgroundColor: TabStyles.Colors.White,
    position: 'absolute',
    $nest: {
      'table': {
        borderSpacing: 0,
        $nest: {
          '&.tb-root-table': {
            marginTop: 0,
            marginBottom: 30,
          },
          'tbody': {
            $nest: {
              'tr': {
                verticalAlign: 'top',
                $nest: {
                  'td': {
                    paddingLeft: TabStyles.Spacing.MediumSpace,
                    paddingRight: TabStyles.Spacing.MediumSpace,
                    $nest: {
                      '&.tb-nested-table': {
                        padding: 0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });

  export const titleText = cssClass(cssPrefix, 'title', {
    fontFamily: 'BentonSans-Book',
    fontSize: '18px',
    textAlign: 'left',
    paddingBottom: '24px',
    paddingTop: '24px',
    paddingLeft: '24px',
    marginBottom: '0px'
  });

  export const labelText = cssClass(cssPrefix, 'label', {
    color: CommonStyles.Colors.Black,
    fontFamily: 'BentonSans-Medium',
    fontSize: CommonStyles.Sizes.NormalFontSize,
    textAlign: 'left',
    paddingBottom: '16px',
    width: '150px',
    paddingLeft: 24,
    $nest: {
      'h4': SpaceContainerStyles.NoStyleHeader
    }
  });

  export const labelWithInfoButtonText = cssClass(cssPrefix, 'label', {
    position: 'relative',
    top: '-3.5px',
  });

  export const emailInfoButton = cssClass(cssPrefix, 'button', {
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    width: '74px !important'
  });

  export const usernameInfoButton = cssClass(cssPrefix, 'button', {
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    width: '96px !important'
  });

  export const tbody = cssClass(cssPrefix, 'body', {
    paddingLeft: CommonStyles.Sizes.DefaultSpace + CommonStyles.Sizes.LargeSpace,
    paddingRight: CommonStyles.Sizes.MediumSpace,
  });

  export const detailsValue = cssClass(cssPrefix, 'details-value', {
    width: '800px',
    fontSize: '12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingBottom: '16px !important',
  });

  export const detailsValueSmallPadding = cssClass(cssPrefix, 'details-value', {
    width: '800px',
    fontSize: '12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingBottom: '8px !important',
  });

  export const buttons = cssClass(cssPrefix, 'buttons', {
    paddingLeft: '150px',
    paddingBottom: '16px !important',
    paddingTop: '8px !important'
  });

  export const cancelButton = cssClass(cssPrefix, 'cancelButton', {
    paddingRight: '12px !important',
    paddingBottom: '16px !important',
    paddingTop: '8px !important'
  });

  export const dropdown = cssClass(cssPrefix, 'dropdown', {
    width: '250px'
  });

  export const dropdownList = cssClass(cssPrefix, 'dropdownList', {
    maxHeight: '421.2px',
    overflowX: 'hidden'
  });

  export const checkBox = cssClass(cssPrefix, 'checkbox', {
    marginLeft: '0px !important',
  });

  export const itemTableName = cssClass(cssPrefix, 'itemTable', {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'InlineBlock',
  });

  export const tableMultilineWithSeparatorRow = cssClass(cssPrefix, 'multiLine', {
    paddingTop: CommonStyles.Sizes.SmallSpace,
    paddingBottom: CommonStyles.Sizes.SmallSpace,
    paddingLeft: CommonStyles.Sizes.MediumSpace,
    paddingRight: CommonStyles.Sizes.MediumSpace,
    height: CommonStyles.Sizes.RowHeight,
    verticalAlign: 'middle',
    borderBottom: `1px solid ${CommonStyles.Colors.DividerLineColor}`,
  });

  export const tableHeaderLine = cssClass(cssPrefix, 'tableHeader', {
    paddingTop: CommonStyles.Sizes.DefaultSpace,
    paddingBottom: CommonStyles.Sizes.DefaultSpace,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    backgroundColor: CommonStyles.Colors.White,
    borderBottom: `1px solid ${CommonStyles.Colors.DividerLineColor}`,
    borderTop: `1px solid ${CommonStyles.Colors.DividerLineColor}`,
  });

  export const securityButton = cssClass(cssPrefix, 'securityButton', {
    textAlign: 'right',
    paddingLeft: '510px',
    paddingTop: '10px'
  });
}